import { render, staticRenderFns } from "./SubGoalSettingsContent.vue?vue&type=template&id=7091d4a1&scoped=true"
import script from "./SubGoalSettingsContent.vue?vue&type=script&lang=js"
export * from "./SubGoalSettingsContent.vue?vue&type=script&lang=js"
import style0 from "./SubGoalSettingsContent.vue?vue&type=style&index=0&id=7091d4a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7091d4a1",
  null
  
)

export default component.exports